import PropTypes from 'prop-types';
import React from 'react';

// Reaxl Components
import Accordion from '../Accordion/index.js';
import AccordionPanel from '../AccordionPanel/index.js';
import ListColumns from '../ListColumns/index.js';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CollapsibleListColumns(_ref) {
  let {
    items = [],
    title,
    collapsed = false,
    render,
    component,
    className,
    xs = 1,
    sm = 3,
    md,
    lg,
    bordered,
    condensed,
    striped,
    hover,
    titleComponentClass = 'div',
    ...rest
  } = _ref;
  const sizes = {
    xs
  };
  let prevSize = xs;
  if (sm && sm !== prevSize) {
    sizes.sm = sm;
    prevSize = sm;
  }
  if (md && md !== prevSize) {
    sizes.md = md;
    prevSize = md;
  }
  if (lg && lg !== prevSize) {
    sizes.lg = lg;
  }
  function renderItemColumns() {
    return /*#__PURE__*/_jsx(ListColumns, {
      className: "list-unstyled",
      items: items,
      render: render,
      component: component,
      bordered: bordered,
      condensed: condensed,
      striped: striped,
      hover: hover,
      ...sizes
    }, "listColumn");
  }
  function renderAccordion() {
    return /*#__PURE__*/_jsx(Accordion, {
      bsStyle: "primary",
      children: /*#__PURE__*/_jsx(AccordionPanel, {
        title: title,
        eventKey: "panel1",
        children: renderItemColumns()
      })
    });
  }
  function renderTitle() {
    const ComponentClass = titleComponentClass;
    return title && /*#__PURE__*/_jsx(ComponentClass, {
      className: "text-bold",
      children: title
    }, "title");
  }
  function renderDefault() {
    return /*#__PURE__*/_jsxs("div", {
      className: "margin-vertical-5",
      children: [renderTitle(), renderItemColumns()]
    });
  }
  function renderSection() {
    return collapsed ? renderAccordion() : renderDefault();
  }
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": "collapsibleListColumns",
    className: className,
    ...rest,
    children: renderSection()
  });
}
export default CollapsibleListColumns;